import { render, staticRenderFns } from "./MediaReviewReportView.vue?vue&type=template&id=2d002655&"
import script from "./MediaReviewReportView.vue?vue&type=script&lang=js&"
export * from "./MediaReviewReportView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports